class VideoExternalPreviewManager {
  private Dictionary: Map<string, string> = new Map();

  public getVideo(sourceId: string) {
    return this.Dictionary.get(sourceId);
  }

  public setVideo(sourceId: string, video: string) {
    this.Dictionary.set(sourceId, video);
  }

  delete(sourceId: string) {
    this.Dictionary.delete(sourceId);
  }

  destroy() {
    const videos = this.Dictionary.values();
    for (const video of videos) {
      this.Dictionary.delete(video);
    }
  }
}

export default new VideoExternalPreviewManager();
